/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';

import AddressFooter from '../../shared/AddressFooter';

const BarberIgAuth = (props) => {
  const { name, link } = props.location.query;
  return (
    <div>
      <Helmet>
        <title>Update to keep your IG pics in Squire!</title>
      </Helmet>
      <div className="c-ig-auth-body">
        <div className="c-ig-squire-logo" />
        <h2 className="c-ig-title">Hi {name}, Happy new year!</h2>
        <p className="c-ig-text-body u-mb-8">
          You previously provided us with your Instagram username in Squire Commander.
          Due to a change with Instagram’s policy,
          we need you to authorize your account in order to preserve your clients’ booking experience.
        </p>
        <div className="c-ig-instruction u-mb-5">
          <div>1</div>
          <p>Click the button below to authorize Squire</p>
        </div>
        <div className="c-ig-instruction u-mb-10">
          <div>2</div>
          <p>Tag the pictures you’d like to populate on Squire app with #getsquire</p>
        </div>
        <a className="c-ig-auth-button" href={link} target="_blank" />
      </div>
      <AddressFooter />
    </div>
  );
};

BarberIgAuth.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withRouter(BarberIgAuth);



// WEBPACK FOOTER //
// ./src/app/notifications/barber/BarberIgAuth/index.jsx